import Vue from 'vue';
import ContactForm from './contact-form.vue';
import Mixins from '../../mixins/mixin';

Vue.mixin(Mixins);

new Vue({
    name: 'contact-form',
    el: '#js-contact-form-wrapper',
    components: {
        'contact-form': ContactForm
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/frontend/vue/components/contact/contact-form.js